__turbopack_context__.v({
  "bgVectors": "tEPoTW_bgVectors",
  "contentWrapper": "tEPoTW_contentWrapper",
  "featureDescription": "tEPoTW_featureDescription" + " " + __turbopack_context__.i(515534)["cardBody"],
  "featureItem": "tEPoTW_featureItem",
  "featureTitle": "tEPoTW_featureTitle" + " " + __turbopack_context__.i(515534)["cardTitle"],
  "header": "tEPoTW_header" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
  "heading": "tEPoTW_heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "leftColumn": "tEPoTW_leftColumn",
  "rightColumn": "tEPoTW_rightColumn",
  "ringImage": "tEPoTW_ringImage",
  "section": "tEPoTW_section",
});
